<div class="search-block" dataAttribute componentName="search-block">
  <div
    *showOnPlatformNarrow="[Platform.Mobile, Platform.Tablet]"
    class="search-block__mobile"
  >
    <div class="search-with-notifications">
      <b2b-portal-search-bar dataAttribute componentName="search-bar" />

      <b2b-portal-notification-bell
        *showOnPlatformNarrow="Platform.Mobile"
        type="search-mobile"
        dataAttribute
        componentName="search-block-notification-bell"
      />
    </div>
  </div>

  <div *showOnPlatformNarrow="Platform.Desktop" class="search-block__desktop">
    <b2b-logo dataAttribute componentName="logo" />

    <tiss-catalog-button />

    <b2b-portal-search-bar variant="secondary" dataAttribute componentName="search-bar" />

    <div class="notification-with-actions">
      <tiss-manager-info />
      <b2b-portal-notification-bell
        dataAttribute
        componentName="search-block-notification-bell"
      />
      <b2b-user-actions />
    </div>
  </div>
</div>
